import { api } from '../api';
import { useQuery, UseQueryResult } from 'react-query';
import { ClientQuery } from '../types/client-query';
import { AxiosError } from 'axios';

type GetClientQueryResponse = {
    clientQuery: ClientQuery;
};

async function getClientQuery(workpaperId: string, clientQueryId: string): Promise<GetClientQueryResponse> {
    const { data } = await api.get(`/workpapers/${workpaperId}/client-queries/${clientQueryId}`);
    return data;
}

export function useClientQuery(workpaperId: string, clientQueryId: string): UseQueryResult<GetClientQueryResponse, AxiosError> {
    return useQuery(['workpapers', workpaperId, 'client-queries', clientQueryId], () => getClientQuery(workpaperId, clientQueryId), {
        keepPreviousData: true,
        retry: false,
    });
}
